module.exports = __webpack_public_path__ + "img/flies.01c1b1aa.svg";